import React, { useState } from "react";
import DropdownMenu from "../../../shared/components/DropdownMenu.tsx";
import { ImportCustomerForm } from "./ImportCustomerForm";
import { ImportProviderForm } from "./ImportProviderForm";
import { ImportMaterialProviderForm } from "./ImportMaterialProviderForm";
import { ImportProductMaterialForm } from "./ImportProductMaterialForm";
import { ImportProductCustomerForm } from "./ImportProductCustomerForm";
import { ImportMaterialStockForm } from "./ImportMaterialStockForm";
import ImportInstructions from "./ImportInstructions";

const importTypes = [
    { text: "Nhập khách hàng", value: "customers" },
    { text: "Nhập nhà cung cấp", value: "providers" },
    { text: "Nhập quan hệ vật tư-nhà cung cấp", value: "material_providers" },
    { text: "Nhập định mức vật tư (BOM)", value: "product_materials" },
    { text: "Nhập quan hệ sản phẩm-khách hàng", value: "product_customers" },
    { text: "Nhập tồn kho vật tư", value: "material_stocks" },
    // Add more import types here in the future
];

const Content = () => {
    const [selectedType, setSelectedType] = useState<string | null>(null);
    const [displayText, setDisplayText] = useState("Chọn loại dữ liệu");

    const handleSelectType = ({ text, value }: { text: string; value: string }) => {
        setDisplayText(text);
        setSelectedType(value);
    };

    return (
        <div className="tw-p-5 tw-w-full tw-box-border tw-overflow-x-hidden" style={{ fontFamily: "Noto Sans" }}>
            <div className="tw-mb-6 tw-w-1/4">
                <DropdownMenu
                    menuList={importTypes}
                    menuText={displayText}
                    handleOnclickItem={handleSelectType}
                />
            </div>

            {selectedType === "customers" && (
                <div className="tw-w-full tw-min-w-0">
                    <ImportCustomerForm />
                </div>
            )}

            {selectedType === "providers" && (
                <div className="tw-w-full tw-min-w-0">
                    <ImportProviderForm />
                </div>
            )}

            {selectedType === "material_providers" && (
                <div className="tw-w-full tw-min-w-0">
                    <ImportMaterialProviderForm />
                </div>
            )}

            {selectedType === "product_materials" && (
                <div className="tw-w-full tw-min-w-0">
                    <ImportProductMaterialForm />
                </div>
            )}

            {selectedType === "product_customers" && (
                <div className="tw-w-full tw-min-w-0">
                    <ImportProductCustomerForm />
                </div>
            )}

            {selectedType === "material_stocks" && (
                <div className="tw-w-full tw-min-w-0">
                    <ImportMaterialStockForm />
                </div>
            )}

            {selectedType === null && <ImportInstructions />}
        </div>
    );
};

export default Content;

